import Component from 'flarum/common/Component';
import Dropdown from 'flarum/common/components/Dropdown';
import icon from 'flarum/common/helpers/icon';
import { locales, localeInfo, currentLocale, alternateUrl, rememberLocale, tt } from '../i18n';

/**
 * Taalkeuze in de kop, enkel op de pagina's van het publieke deel.
 *
 * Op desktop en tablet een compacte keuzelijst ("FR ▾"), zoals Flarum zelf een taalkeuze
 * toont: de kop heeft maar enkele pixels over. In de mobiele lade een rij NL | FR | EN
 * met grote raakvlakken. Elke taal is een gewone link naar dezelfde pagina in die taal
 * (volledige paginalading, zodat titel, metadata en inhoud meteen kloppen). Een klik
 * onthoudt de keuze; er wordt nooit automatisch van taal gewisseld.
 */
export default class LanguageSwitcher extends Component {
  view() {
    const current = currentLocale();
    const name = localeInfo(current).name;

    const link = (locale, content, className) => {
      const active = locale === current;
      const label = localeInfo(locale).name;
      return (
        <a
          className={className + (active ? ' is-active' : '')}
          href={alternateUrl(locale)}
          hreflang={locale}
          lang={locale}
          aria-label={active ? tt('i18n.current', { language: label }) : label}
          aria-current={active ? 'true' : undefined}
          onclick={() => rememberLocale(locale)}
        >
          {content(active, label)}
        </a>
      );
    };

    return (
      <div className="LcLangSwitch">
        <Dropdown
          className="LcLangSwitch-dropdown"
          buttonClassName="Button Button--link"
          menuClassName="Dropdown-menu--right"
          label={current.toUpperCase()}
          accessibleToggleLabel={`${tt('i18n.label')}: ${name}`}
        >
          {locales().map((locale) =>
            link(locale, (active, label) => [icon(active ? 'fas fa-check' : '', { className: 'Button-icon' }), <span className="Button-label">{label}</span>], 'Button Button--link hasIcon')
          )}
        </Dropdown>

        <nav className="LcLangSwitch-inline" aria-label={tt('i18n.label')}>
          <ul>
            {locales().map((locale) => (
              <li>{link(locale, () => locale.toUpperCase(), 'LcLangSwitch-link')}</li>
            ))}
          </ul>
        </nav>
      </div>
    );
  }
}
